var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37402 6.60023C10.5188 6.45757 11.4047 5.48102 11.4047 4.29755C11.4047 3.11409 10.5188 2.13754 9.37402 1.99487C9.91573 2.60853 10.2444 3.41465 10.2444 4.29755C10.2444 5.18045 9.91573 5.98658 9.37402 6.60023Z",
    fill: "#535763"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5649 11.8396C12.5649 12.16 12.8246 12.4197 13.145 12.4197C13.4655 12.4197 13.7252 12.16 13.7252 11.8396V10.6793C13.7252 9.136 12.52 7.87421 10.9995 7.78369C11.6099 8.32425 12.0768 9.02312 12.3361 9.81598C12.4817 10.0704 12.5649 10.3651 12.5649 10.6793V11.8396Z",
    fill: "#535763"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02308 8.93887C4.06185 8.93887 3.28262 9.7181 3.28262 10.6793V11.8396C3.28262 12.16 3.02288 12.4198 2.70247 12.4198C2.38206 12.4198 2.12231 12.16 2.12231 11.8396V10.6793C2.12231 9.07728 3.42103 7.77856 5.02308 7.77856H8.50399C10.106 7.77856 11.4048 9.07728 11.4048 10.6793V11.8396C11.4048 12.16 11.145 12.4198 10.8246 12.4198C10.5042 12.4198 10.2445 12.16 10.2445 11.8396V10.6793C10.2445 9.7181 9.46522 8.93887 8.50399 8.93887H5.02308Z",
    fill: "#535763"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76348 3.13736C6.12266 3.13736 5.60318 3.65684 5.60318 4.29766C5.60318 4.93848 6.12266 5.45797 6.76348 5.45797C7.4043 5.45797 7.92379 4.93848 7.92379 4.29766C7.92379 3.65684 7.4043 3.13736 6.76348 3.13736ZM4.44287 4.29766C4.44287 3.01602 5.48184 1.97705 6.76348 1.97705C8.04512 1.97705 9.08409 3.01602 9.08409 4.29766C9.08409 5.5793 8.04512 6.61827 6.76348 6.61827C5.48184 6.61827 4.44287 5.5793 4.44287 4.29766Z",
    fill: "#535763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferFriend);
export default __webpack_public_path__ + "static/media/referFriend.7ed5d3810f2c70067499679887e6a1e7.svg";
export { ForwardRef as ReactComponent };